import { type FilterConfig } from '../interfaces';

import { groupFilterConfigMultiple } from './default-config-multiple';

export const groupFilterConfigSingle: FilterConfig = {
  ...groupFilterConfigMultiple,
  multiple: false,
};
